import { useEffect } from "react";
import { faqs } from "@/mocks/comicData";

export default function Seo() {
  useEffect(() => {
    const siteUrl = "https://cureverse5.github.io/";
    const data = [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "天才医仙漫画追更站",
        url: siteUrl,
        description: "天才医仙漫画最新章节免费追更，收藏自动提醒，连载进度一眼便知。",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "天才医仙漫画追更站",
        url: siteUrl,
        description: "天才医仙漫画最新章节免费追更与连载进度查询。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "天才医仙漫画最新章节免费追更",
        url: siteUrl,
        inLanguage: "zh-CN",
        isPartOf: { "@type": "WebSite", url: siteUrl },
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: siteUrl },
          { "@type": "ListItem", position: 2, name: "天才医仙漫画最新章节", item: siteUrl },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(data);
    script.setAttribute("data-seo", "jsonld");
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}